import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { BreadcrumbType } from "types";

interface InitialState {
	loadingPage: boolean;
	breadcrumbs: BreadcrumbType[];
}

const initialState: InitialState = {
	loadingPage: false,
	breadcrumbs: [],
};

export const appSlice = createSlice({
	name: "app",
	initialState,
	reducers: {
		setLoadingPage: (state, action) => {
			state.loadingPage = action.payload;
		},
		setBreadCrumbs: (state, action) => {
			state.breadcrumbs = action.payload;
		},
	},
});

export const { setLoadingPage, setBreadCrumbs } = appSlice.actions;

export const selectLoadingPage = (state: RootState) => state.app.loadingPage;
export const selectBreadcrumbs = (state: RootState) => state.app.breadcrumbs;

export default appSlice.reducer;
